import { handleAxiosError } from "../utils/errorHandler";
import axiosInstance from "./axiosInstance";

export const fetchAllOdbernaMista = async () => {
  try {
    const response = await axiosInstance.get(`/api/collection-points`);
    return { success: true, data: response.data };
  } catch (error) {
    const { status, message } = handleAxiosError(
      error,
      "Chyba při načítání seznamu míst odběru."
    );
    return { success: false, status, message };
  }
};

export const fetchOdberneMisto = async (collectionPointNumber) => {
  try {
    const response = await axiosInstance.get(
      `/api/collection-points/${collectionPointNumber}`
    );
    return { success: true, data: response.data };
  } catch (error) {
    // Zpracujeme chybu a vrátíme status + zprávu
    const { status, message } = handleAxiosError(
      error,
      "Chyba při načítání detailu místa odběru."
    );
    return {
      success: false,
      status,
      message,
    };
  }
};

export const submitStavVodomeru = async (payload) => {
  try {
    const response = await axiosInstance.post(
      `/api/collection-points/submit`,
      payload
    );
    return { success: true, data: response.data };
  } catch (error) {
    const { status, message } = handleAxiosError(
      error,
      "Chyba při odesílání stavu vodoměru."
    );
    return {
      success: false,
      status,
      message,
    };
  }
};
